<template>
  <div class="list-scroll">
    <div class="plan-list">
      <div
        class="plan-item"
        v-for="(item, index) in data"
        :key="index"
        @click="bindClick(item)"
      >
        <div class="mask" v-if="item.disabled"></div>
        <div class="title">科学定制营养方案</div>
        <div class="desc">每月可生成1次</div>
        <div class="btn" :class="{ 'btn-disabled': item.disabled }"
          ><span>{{ item.btnText }}</span
          ><span class="iconfont icon-you"></span
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
    count: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {}
  },
  created() {},
  methods: {
    bindClick(item) {
      let id = item.id
      let cnaType = item.cnaType
      if (cnaType == 1) {
        switch (item.plan_flag) {
          case -1:
            break
          case 3:
            if (item.success) {
              this.$router.push('/recipe-cna-result?rid=' + id)
            } else {
              this.$router.push('/recipe-cna-submit?rid=' + id + '&sfrom=weVip')
            }
            break
          default:
            this.$router.push('/recipe-cna-start?rid=' + id)
        }
      } else {
        switch (item.cna_state) {
          case 1:
            this.$router.push('/cna-question-v2/start?queId=9&id=' + id)
            break
          case 2:
            this.$router.push('/cna-question-v2/start?queId=9&id=' + id)
            break
          case 3:
            this.$router.push('/cna-question-v2/result?id=' + id)
            break
          default:
            this.$toat('方案已失效')
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.list-scroll {
  padding: 0px 14px;
  overflow-y: scroll;

  .plan-list {
    display: inline-flex;
    align-items: center;

    .plan-item {
      position: relative;
      padding: 12px 16px;
      box-sizing: border-box;
      width: 283px;
      height: 96px;
      border-radius: 8px;
      background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/1930fb79bc995cd08e0afe1c59030003.png');
      background-repeat: no-repeat;
      background-size: contain;
      margin-right: 10px;

      .mask {
        background-color: rgba(255, 255, 255, 0.2);
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        z-index: 1;
      }

      .title {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.8);
        line-height: 24px;
        margin-bottom: 5px;
      }

      .desc {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: rgba(0, 0, 0, 0.8);
        line-height: 14px;
      }

      .btn {
        position: absolute;
        z-index: 2;
        top: 50%;
        right: 16px;
        transform: translate(0%, -50%);
        height: 30px;
        background: linear-gradient(90deg, #9490ee 0%, #776fe0 100%);
        border-radius: 15px;
        padding: 0px 6px 0px 10px;
        font-size: 14px;
        font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
        font-weight: 600;
        color: #ffffff;
        display: flex;
        align-items: center;

        .iconfont {
          margin-left: 2px;
        }
      }

      .btn-disabled {
        background: linear-gradient(90deg, #babbc5 0%, #9fa0a8 100%);
      }
    }

    .plan-item:last-child {
      margin-right: 0;
    }
  }
}
</style>
